import Footer from "./components/HomeComponents/Footer";
import Navbar from "./components/HomeComponents/Navbar";
import Home from "./pages/Home";
import Academies from "./pages/Academies";
import Students from "./pages/Students";
import PrivacyPolicy from "./components/HomeComponents/PrivacyPolicy";
import ThankYou from "./pages/ThankYou";


import { useEffect } from 'react';
import {
  Routes,
  Route,
  useLocation
} from 'react-router-dom';
import TermsConditions from "./components/HomeComponents/TermsConditions";
import AboutUs from "./pages/AboutUs";

import { lazy, Suspense } from 'react';

// Lazy load blog components
const BlogList = lazy(() => import('./components/Blog/BlogList'));
const BlogDetail = lazy(() => import('./components/Blog/BlogDetail'));

  const Loadable = (Component) => {
  return function WrappedComponent() {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <Component />
      </Suspense>
    );
  };
};

const BlogListLazy = Loadable(BlogList);
const BlogDetailLazy = Loadable(BlogDetail);

function App() {
  
  const location = useLocation();
  
  // Immediately redirect if path is /login without rendering any UI
  useEffect(() => {
    if (location.pathname === '/login') {
      window.location.replace(`${process.env.REACT_APP_LOGIN_URL}/login`);
    }
  }, [location]);
  
  // Don't render anything if we're on the login path
  if (location.pathname === '/login') {
    return null;
  }

  
  return (
    <>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/academies" element={<Academies />} />
          <Route path="/students" element={<Students />} />
          <Route path="/blog" element={<BlogListLazy />} />
          <Route path="/blog/:id" element={<BlogDetailLazy/>} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/thank-you" element={<ThankYou />} />

          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
    </>
  );
}

export default App;
